import { render, staticRenderFns } from "./AuthFormLinkNew.vue?vue&type=template&id=4c5591ba"
import script from "./AuthFormLinkNew.vue?vue&type=script&lang=ts"
export * from "./AuthFormLinkNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c5591ba')) {
      api.createRecord('4c5591ba', component.options)
    } else {
      api.reload('4c5591ba', component.options)
    }
    module.hot.accept("./AuthFormLinkNew.vue?vue&type=template&id=4c5591ba", function () {
      api.rerender('4c5591ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/AuthFormLinkNew.vue"
export default component.exports